module.exports = __webpack_public_path__ + "img/1-1.7de64c74.svg";